<div class="ecommerce-admin-container">
  <!-- Header Section -->
  <div class="row mb-4">
    <div class="col-md-8">
      <div class="d-flex align-items-center">
        <button *ngIf="role !== 'receipt_auditor'" class="btn btn-outline-secondary me-3" (click)="goBackToStores()">
          <nb-icon icon="arrow-back-outline"></nb-icon>
          Back to Stores
        </button>
        <button *ngIf="role === 'receipt_auditor'" class="btn btn-outline-secondary me-3" (click)="goBackToAuditor()">
          <nb-icon icon="arrow-back-outline"></nb-icon>
          Back
        </button>
        <div>
          <h2 class="mb-1">{{ storeName }}{{ role === 'receipt_auditor' ? ' - Orders' : ' - Ecommerce Admin' }}</h2>
          <p *ngIf="role !== 'receipt_auditor'" class="text-muted mb-0">Manage products, orders, and analytics for this store</p>
        </div>
      </div>
    </div>
    <div *ngIf="role !== 'receipt_auditor'" class="col-md-4 text-end">
      <div class="d-flex align-items-center justify-content-end">
        <span class="me-3">Ecommerce Status:</span>
        <nb-toggle 
          [checked]="isEcommerceEnabled"
          (checkedChange)="toggleEcommerce()"
          status="success">
        </nb-toggle>
        <span class="ms-2" [class.text-success]="isEcommerceEnabled" [class.text-danger]="!isEcommerceEnabled">
          {{ isEcommerceEnabled ? 'Enabled' : 'Disabled' }}
        </span>
      </div>
    </div>
  </div>

  <!-- Navigation Tabs -->
  <nb-card class="mb-4">
    <nb-card-body class="p-0">
      <nav class="nav nav-tabs custom-tabs">
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'overview'"
          (click)="setActiveTab('overview')"
          href="javascript:void(0)">
          <nb-icon icon="home-outline" class="me-2"></nb-icon>
          {{ 'KPI.OVERVIEW.TITLE' | translate }}
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'dashboard'"
          (click)="setActiveTab('dashboard')"
          href="javascript:void(0)">
          <nb-icon icon="grid-outline" class="me-2"></nb-icon>
          Dashboard
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'products'"
          (click)="setActiveTab('products')"
          href="javascript:void(0)">
          <nb-icon icon="cube-outline" class="me-2"></nb-icon>
          Products
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'categories'"
          (click)="setActiveTab('categories')"
          href="javascript:void(0)">
          <nb-icon icon="layers-outline" class="me-2"></nb-icon>
          Categories
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'discount-groups'"
          (click)="setActiveTab('discount-groups')"
          href="javascript:void(0)">
          <nb-icon icon="pricetags-outline" class="me-2"></nb-icon>
          Discount groups
        </a>
        <a 
          class="nav-link" 
          [class.active]="activeTab === 'orders'"
          (click)="setActiveTab('orders')"
          href="javascript:void(0)">
          <nb-icon icon="shopping-cart-outline" class="me-2"></nb-icon>
          Orders
        </a>
        <a 
          *ngIf="role === 'manager' || role === 'admin'"
          class="nav-link" 
          [class.active]="activeTab === 'terminal-log'"
          (click)="setActiveTab('terminal-log')"
          href="javascript:void(0)">
          <nb-icon icon="credit-card-outline" class="me-2"></nb-icon>
          {{ 'TERMINAL_LOG.TAB_TITLE' | translate }}
        </a>
        <a 
          *ngIf="role === 'manager' || role === 'admin'"
          class="nav-link" 
          [class.active]="activeTab === 'pos-diagnostics'"
          (click)="setActiveTab('pos-diagnostics')"
          href="javascript:void(0)">
          <nb-icon icon="activity-outline" class="me-2"></nb-icon>
          POS Diagnostics
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'inventory'"
          (click)="setActiveTab('inventory')"
          href="javascript:void(0)">
          <nb-icon icon="archive-outline" class="me-2"></nb-icon>
          Inventory
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'analytics'"
          (click)="setActiveTab('analytics')"
          href="javascript:void(0)">
          <nb-icon icon="bar-chart-outline" class="me-2"></nb-icon>
          Analytics
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'financial'"
          (click)="setActiveTab('financial')"
          href="javascript:void(0)">
          <nb-icon icon="credit-card-outline" class="me-2"></nb-icon>
          Financial
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'import'"
          (click)="setActiveTab('import')"
          href="javascript:void(0)">
          <nb-icon icon="cloud-upload-outline" class="me-2"></nb-icon>
          Import
        </a>
        <a
          *ngIf="role === 'admin' || role === 'manager' || role === 'chain_manager'"
          class="nav-link"
          [class.active]="activeTab === 'invoice-imports'"
          (click)="setActiveTab('invoice-imports')"
          href="javascript:void(0)">
          <nb-icon icon="file-text-outline" class="me-2"></nb-icon>
          {{ 'INVOICE_IMPORTS.TITLE' | translate }}
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'image-library'"
          (click)="setActiveTab('image-library')"
          href="javascript:void(0)">
          <nb-icon icon="image-outline" class="me-2"></nb-icon>
          Image Library
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'settings'"
          (click)="setActiveTab('settings')"
          href="javascript:void(0)">
          <nb-icon icon="settings-outline" class="me-2"></nb-icon>
          Settings
        </a>
        <a 
          *ngIf="role === 'manager' || role === 'admin'"
          class="nav-link" 
          [class.active]="activeTab === 'loyalty'"
          (click)="setActiveTab('loyalty')"
          href="javascript:void(0)">
          <nb-icon icon="award-outline" class="me-2"></nb-icon>
          Loyalty
        </a>
        <a 
          *ngIf="role === 'manager' || role === 'admin'"
          class="nav-link" 
          [class.active]="activeTab === 'loyalty-analytics'"
          (click)="setActiveTab('loyalty-analytics')"
          href="javascript:void(0)">
          <nb-icon icon="bar-chart-2-outline" class="me-2"></nb-icon>
          Loyalty Analytics
        </a>
        <a 
          class="nav-link" 
          [class.active]="activeTab === 'basket-audit'"
          (click)="setActiveTab('basket-audit')"
          href="javascript:void(0)">
          <nb-icon icon="shield-outline" class="me-2"></nb-icon>
          Basket Audit
        </a>
        <a 
          class="nav-link" 
          [class.active]="activeTab === 'electronic-journal'"
          (click)="setActiveTab('electronic-journal')"
          href="javascript:void(0)">
          <nb-icon icon="file-text-outline" class="me-2"></nb-icon>
          Electronic Journal
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'fiscal-reports'"
          (click)="setActiveTab('fiscal-reports')"
          href="javascript:void(0)">
          <nb-icon icon="clipboard-outline" class="me-2"></nb-icon>
          Fiscal Reports
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor'"
          class="nav-link" 
          [class.active]="activeTab === 'unmatched-barcodes'"
          (click)="setActiveTab('unmatched-barcodes')"
          href="javascript:void(0)">
          <nb-icon icon="alert-triangle-outline" class="me-2"></nb-icon>
          Unmatched Barcodes
        </a>
        <a 
          *ngIf="role !== 'receipt_auditor' && breeceEnabled"
          class="nav-link" 
          [class.active]="activeTab === 'breece-sync'"
          (click)="setActiveTab('breece-sync')"
          href="javascript:void(0)">
          <nb-icon icon="monitor-outline" class="me-2"></nb-icon>
          Breece Sync Log
        </a>
      </nav>
    </nb-card-body>
  </nb-card>

  <!-- Content Area -->
  <div class="tab-content">
    <!-- Overview Tab -->
    <div *ngIf="activeTab === 'overview'" class="tab-pane active">
      <app-store-overview [storeId]="storeId"></app-store-overview>
    </div>

    <!-- Dashboard Tab -->
    <div *ngIf="activeTab === 'dashboard'" class="tab-pane active">
      <app-analytics-dashboard
        [storeId]="storeId"
        [dashboardData]="dashboardData"
        [dashboardLoading]="dashboardLoading"
        (refreshRequested)="loadDashboardData(currentDashboardFilter)"
        (filterChange)="onDashboardFilterChange($event)">
      </app-analytics-dashboard>
    </div>

    <!-- Products Tab -->
    <div *ngIf="activeTab === 'products'" class="tab-pane active">
      <app-product-management [storeId]="storeId" [storeConfig]="storeConfig"></app-product-management>
    </div>

    <!-- Categories Tab -->
    <div *ngIf="activeTab === 'categories'" class="tab-pane active">
      <app-category-management [storeId]="storeId"></app-category-management>
    </div>

    <!-- Discount groups Tab -->
    <div *ngIf="activeTab === 'discount-groups'" class="tab-pane active">
      <app-discount-group-offers [storeId]="storeId"></app-discount-group-offers>
    </div>

    <!-- Orders Tab -->
    <div *ngIf="activeTab === 'orders'" class="tab-pane active">
      <app-order-management [storeId]="storeId" [initialOrderNumber]="orderNumberFilter"></app-order-management>
    </div>

    <!-- Terminal Log Tab -->
    <div *ngIf="activeTab === 'terminal-log' && (role === 'manager' || role === 'admin')" class="tab-pane active">
      <app-terminal-log [storeId]="storeId"></app-terminal-log>
    </div>

    <!-- POS Diagnostics Tab -->
    <div *ngIf="activeTab === 'pos-diagnostics' && (role === 'manager' || role === 'admin')" class="tab-pane active">
      <app-pos-diagnostics [storeId]="storeId"></app-pos-diagnostics>
    </div>

    <!-- Inventory Tab -->
    <div *ngIf="activeTab === 'inventory'" class="tab-pane active">
      <app-inventory-dashboard [storeId]="storeId"></app-inventory-dashboard>
    </div>

    <!-- Analytics Tab -->
    <div *ngIf="activeTab === 'analytics'" class="tab-pane active">
      <app-advanced-analytics [storeId]="storeId"></app-advanced-analytics>
    </div>

    <!-- Financial Tab -->
    <div *ngIf="activeTab === 'financial'" class="tab-pane active">
      <app-financial-dashboard [storeId]="storeId"></app-financial-dashboard>
    </div>

    <!-- Import Tab -->
    <div *ngIf="activeTab === 'import'" class="tab-pane active">
      <app-csv-import [storeId]="storeId"></app-csv-import>
    </div>

    <!-- Supplier invoices (Leverandørfakturaer) -->
    <div
      *ngIf="activeTab === 'invoice-imports' && (role === 'admin' || role === 'manager' || role === 'chain_manager')"
      class="tab-pane active">
      <app-invoice-imports [storeId]="storeId"></app-invoice-imports>
    </div>

    <!-- Image Library Tab -->
    <div *ngIf="activeTab === 'image-library'" class="tab-pane active">
      <app-image-library [storeId]="storeId"></app-image-library>
    </div>

    <!-- Settings Tab -->
    <div *ngIf="activeTab === 'settings'" class="tab-pane active">
      <app-store-config [storeId]="storeId" [storeConfig]="storeConfig" (configUpdated)="refreshData()"></app-store-config>
    </div>

    <!-- Loyalty Tab -->
    <div *ngIf="activeTab === 'loyalty' && (role === 'manager' || role === 'admin')" class="tab-pane active">
      <app-loyalty-admin [storeId]="storeId"></app-loyalty-admin>
    </div>

    <!-- Loyalty Analytics Tab -->
    <div *ngIf="activeTab === 'loyalty-analytics' && (role === 'manager' || role === 'admin')" class="tab-pane active">
      <app-loyalty-analytics [storeId]="storeId"></app-loyalty-analytics>
    </div>

    <!-- Basket Audit Tab -->
    <div *ngIf="activeTab === 'basket-audit'" class="tab-pane active">
      <app-basket-audit-hub [storeId]="storeId"></app-basket-audit-hub>
    </div>

    <!-- Electronic Journal Tab -->
    <div *ngIf="activeTab === 'electronic-journal'" class="tab-pane active">
      <app-electronic-journal [storeId]="storeId"></app-electronic-journal>
    </div>

    <!-- Fiscal Reports Tab -->
    <div *ngIf="activeTab === 'fiscal-reports'" class="tab-pane active">
      <app-fiscal-reports [storeId]="storeId" [storeName]="storeName"></app-fiscal-reports>
    </div>

    <!-- Unmatched Barcodes Tab -->
    <div *ngIf="activeTab === 'unmatched-barcodes'" class="tab-pane active">
      <app-unmatched-barcodes [storeId]="storeId"></app-unmatched-barcodes>
    </div>

    <!-- Breece Sync Log Tab -->
    <div *ngIf="activeTab === 'breece-sync' && breeceEnabled" class="tab-pane active">
      <app-breece-sync-log [storeId]="storeId"></app-breece-sync-log>
    </div>
  </div>

  <!-- Disabled State Overlay -->
  <div *ngIf="!isEcommerceEnabled && role !== 'receipt_auditor'" class="disabled-overlay">
    <nb-card class="text-center">
      <nb-card-body>
        <nb-icon icon="alert-circle-outline" class="large-icon text-warning mb-3"></nb-icon>
        <h4>Ecommerce is Disabled</h4>
        <p class="text-muted">Enable ecommerce for this store to access all features.</p>
        <button class="btn btn-primary" (click)="toggleEcommerce()">
          Enable Ecommerce
        </button>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<!-- Loading Spinner -->
<ngx-spinner 
  bdColor="rgba(51,51,51,0.8)" 
  size="large" 
  color="white" 
  type="ball-circus"
  [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner>